/**
 * Renders a desktop browser frame with address bar in light mode.
 */
export function DesktopFrameLight(props: { width: number; height: number; url?: string }) {
    const { width = '937', height = '616', url = '' } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 937 616"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Desktop Frame</title>
            <g filter="url(#filter0_d_378_3433)">
                <rect x="12" y="10" width="913" height="592" rx="8" fill="#F5F7F9" />
                <rect x="12.5" y="10.5" width="912" height="591" rx="7.5" stroke="#D3DCE4" />
            </g>
            <rect x="99" y="50" width="809" height="24" rx="8" fill="#F5F7F9" />
            <rect x="13" y="42" width="911" height="40" fill="white" />
            <path
                d="M38.7997 61.3748H31.3457L34.7698 57.8818L33.9004 57L29 62.0005L33.9004 67L34.7635 66.1193L31.3457 62.6252H38.8008L38.7997 61.3748ZM59.1006 57L58.2365 57.8807L61.6543 61.3748H54.2003V62.6252H61.6553L58.2365 66.1182L59.1006 67L64 62.0005L59.1006 57Z"
                fill="#8899A8"
            />
            <path
                d="M84.5257 58.4679C84.0629 58.0022 83.5124 57.6327 82.9061 57.3807C82.2998 57.1288 81.6496 56.9994 80.993 57C80.3367 57 79.6868 57.1294 79.0806 57.3808C78.4743 57.6322 77.9235 58.0006 77.4598 58.4651C76.996 58.9295 76.6284 59.4808 76.3779 60.0875C76.1274 60.6941 75.999 61.3442 76 62.0005C75.9992 62.6568 76.1277 63.3067 76.3782 63.9133C76.6288 64.5198 76.9964 65.071 77.4602 65.5353C77.9239 65.9996 78.4746 66.368 79.0808 66.6193C79.687 66.8706 80.3368 67 80.993 67C82.1005 66.9998 83.1763 66.6311 84.0512 65.9522C84.9261 65.2733 85.5502 64.3226 85.8254 63.2499H84.5257C84.2682 63.9809 83.7902 64.6141 83.1577 65.062C82.5251 65.5099 81.7692 65.7506 80.9941 65.7507C78.9251 65.7507 77.244 64.0685 77.244 62.0005C77.244 59.9315 78.9251 58.2504 80.9941 58.2504C81.4857 58.2511 81.9722 58.3498 82.4251 58.5408C82.8781 58.7317 83.2884 59.0111 83.6321 59.3626L81.6188 61.3748H85.9946V57L84.5257 58.4679V58.4679Z"
                fill="#3B454E"
            />
            <rect x="99" y="50" width="809" height="24" rx="8" fill="#F5F7F9" />
            <text id="textUrl" x="125" y="67" fontFamily="Arial" fontSize="12" fill="#333">
                {url}
            </text>
            <path
                d="M114 60.3333H113.5V59.381C113.5 58.7495 113.237 58.1439 112.768 57.6974C112.299 57.2508 111.663 57 111 57C110.337 57 109.701 57.2508 109.232 57.6974C108.763 58.1439 108.5 58.7495 108.5 59.381V60.3333H108C107.45 60.3333 107 60.7619 107 61.2857V66.0476C107 66.5714 107.45 67 108 67H114C114.55 67 115 66.5714 115 66.0476V61.2857C115 60.7619 114.55 60.3333 114 60.3333ZM111 64.619C110.45 64.619 110 64.1905 110 63.6667C110 63.1429 110.45 62.7143 111 62.7143C111.55 62.7143 112 63.1429 112 63.6667C112 64.1905 111.55 64.619 111 64.619ZM112.55 60.3333H109.45V59.381C109.45 58.5667 110.145 57.9048 111 57.9048C111.855 57.9048 112.55 58.5667 112.55 59.381V60.3333Z"
                fill="#3B454E"
            />
            <circle cx="32" cy="26" r="4" fill="#D33D3D" />
            <circle cx="44" cy="26" r="4" fill="#FFD80B" />
            <circle cx="56" cy="26" r="4" fill="#4DDE98" />
            <rect x="12" y="82" width="912" height="1" fill="#D3DCE4" />
            <defs>
                <filter
                    id="filter0_d_378_3433"
                    x="0"
                    y="0"
                    width="937"
                    height="616"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="6" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_378_3433"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_378_3433"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

/**
 * Renders a desktop browser frame with address bar in dark mode.
 */
export function DesktopFrameDark(props: { width: number; height: number; url?: string }) {
    const { width, height, url = '' } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 937 616"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Desktop Frame</title>
            <g filter="url(#filter0_d_378_3433)">
                <rect x="12" y="10" width="913" height="592" rx="8" fill="#22272E" />
                <rect x="12.5" y="10.5" width="912" height="591" rx="7.5" stroke="#2D323A" />
            </g>
            <rect x="99" y="50" width="809" height="24" rx="8" fill="#22272E" />
            <rect x="13" y="42" width="911" height="40" fill="#14171C" />
            <path
                d="M38.7997 61.3748H31.3457L34.7698 57.8818L33.9004 57L29 62.0005L33.9004 67L34.7635 66.1193L31.3457 62.6252H38.8008L38.7997 61.3748ZM59.1006 57L58.2365 57.8807L61.6543 61.3748H54.2003V62.6252H61.6553L58.2365 66.1182L59.1006 67L64 62.0005L59.1006 57Z"
                fill="#DEDFE3"
            />
            <path
                d="M84.5257 58.4679C84.0629 58.0022 83.5124 57.6327 82.9061 57.3807C82.2998 57.1288 81.6496 56.9994 80.993 57C80.3367 57 79.6868 57.1294 79.0806 57.3808C78.4743 57.6322 77.9235 58.0006 77.4598 58.4651C76.996 58.9295 76.6284 59.4808 76.3779 60.0875C76.1274 60.6941 75.999 61.3442 76 62.0005C75.9992 62.6568 76.1277 63.3067 76.3782 63.9133C76.6288 64.5198 76.9964 65.071 77.4602 65.5353C77.9239 65.9996 78.4746 66.368 79.0808 66.6193C79.687 66.8706 80.3368 67 80.993 67C82.1005 66.9998 83.1763 66.6311 84.0512 65.9522C84.9261 65.2733 85.5502 64.3226 85.8254 63.2499H84.5257C84.2682 63.9809 83.7902 64.6141 83.1577 65.062C82.5251 65.5099 81.7692 65.7506 80.9941 65.7507C78.9251 65.7507 77.244 64.0685 77.244 62.0005C77.244 59.9315 78.9251 58.2504 80.9941 58.2504C81.4857 58.2511 81.9722 58.3498 82.4251 58.5408C82.8781 58.7317 83.2884 59.0111 83.6321 59.3626L81.6188 61.3748H85.9946V57L84.5257 58.4679V58.4679Z"
                fill="#DEDFE3"
            />
            <rect x="99" y="50" width="809" height="24" rx="8" fill="#22272E" />
            <text id="textUrl" x="125" y="67" fontFamily="Arial" fontSize="12" fill="#DEDFE3">
                {url}
            </text>
            <path
                d="M114 60.3333H113.5V59.381C113.5 58.7495 113.237 58.1439 112.768 57.6974C112.299 57.2508 111.663 57 111 57C110.337 57 109.701 57.2508 109.232 57.6974C108.763 58.1439 108.5 58.7495 108.5 59.381V60.3333H108C107.45 60.3333 107 60.7619 107 61.2857V66.0476C107 66.5714 107.45 67 108 67H114C114.55 67 115 66.5714 115 66.0476V61.2857C115 60.7619 114.55 60.3333 114 60.3333ZM111 64.619C110.45 64.619 110 64.1905 110 63.6667C110 63.1429 110.45 62.7143 111 62.7143C111.55 62.7143 112 63.1429 112 63.6667C112 64.1905 111.55 64.619 111 64.619ZM112.55 60.3333H109.45V59.381C109.45 58.5667 110.145 57.9048 111 57.9048C111.855 57.9048 112.55 58.5667 112.55 59.381V60.3333Z"
                fill="#DEDFE3"
            />
            <circle cx="32" cy="26" r="4" fill="#D33D3D" />
            <circle cx="44" cy="26" r="4" fill="#FFD80B" />
            <circle cx="56" cy="26" r="4" fill="#4DDE98" />
            <rect x="12" y="82" width="912" height="1" fill="#2D323A" />
            <defs>
                <filter
                    id="filter0_d_378_3433"
                    x="0"
                    y="0"
                    width="937"
                    height="616"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="6" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_378_3433"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_378_3433"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
